import { type VariantProps, cv, cx } from "@suse-o11y/class-variance";
import React from "react";

import { Alert, type AlertVariant } from "~/components/alert";
import { Logo } from "~/components/logo";

import k8sBackdrop from "./assets/k8s-stackstate-backdrop.svg";

const variants = cv("flex flex-col items-center rounded-3xl bg-white/75 p-12 backdrop-blur-xs", {
	variants: {
		size: {
			sm: "w-[510px]",
			md: "w-[640px]",
		},
	},

	defaultVariants: {
		size: "md",
	},
});

interface SystemMessageLayoutProps extends VariantProps<typeof variants> {
	className?: string;
	alertVariant?: AlertVariant;
	alertContent?: React.ReactNode;
	/**
	 * @default true
	 */
	showLogo?: boolean;
}

export const SystemScreen: React.FC<React.PropsWithChildren<SystemMessageLayoutProps>> = ({
	className,
	size,
	alertVariant,
	alertContent,
	showLogo = true,
	children,
}) => (
	<div
		className={cx("flex items-center justify-center bg-center bg-cover bg-no-repeat p-8", className)}
		style={{
			backgroundImage: `url('${k8sBackdrop}')`,
		}}
	>
		<div className={variants({ size, className: null })}>
			{showLogo && <Logo />}

			{alertContent && (
				<Alert className="mt-14 first:mt-0" variant={alertVariant}>
					{alertContent}
				</Alert>
			)}

			<div className="mt-10 w-[510px] max-w-full text-center text-base first:mt-0">{children}</div>
		</div>
	</div>
);
